import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

/** Auto-rotating promotional banners managed from Admin → Content. */
export default function BannerCarousel({ banners = [] }) {
  const [i, setI] = useState(0);

  useEffect(() => {
    if (banners.length < 2) return undefined;
    const t = setInterval(() => setI((n) => (n + 1) % banners.length), 5000);
    return () => clearInterval(t);
  }, [banners.length]);

  if (!banners.length) return null;
  const b = banners[i];

  return (
    <section className="section pt-4">
      <div className="relative h-56 overflow-hidden rounded-xl border border-white/10 sm:h-72 md:h-80">
        <AnimatePresence mode="wait">
          <motion.div
            key={b._id || b.id || i}
            initial={{ opacity: 0, scale: 1.04 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.7 }}
            className="absolute inset-0"
          >
            <img src={b.image} alt={b.title} className="h-full w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-r from-ink-950/90 via-ink-950/40 to-transparent" />
            <div className="absolute inset-0 flex flex-col justify-center gap-3 p-8 sm:p-12">
              <motion.h2
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.15 }}
                className="max-w-lg font-display text-2xl font-extrabold text-white sm:text-4xl"
              >
                {b.title}
              </motion.h2>
              {b.subtitle && (
                <motion.p
                  initial={{ y: 20, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ delay: 0.25 }}
                  className="max-w-md text-ink-200"
                >
                  {b.subtitle}
                </motion.p>
              )}
            </div>
          </motion.div>
        </AnimatePresence>

        {banners.length > 1 && (
          <div className="absolute bottom-4 left-1/2 flex -translate-x-1/2 gap-2">
            {banners.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setI(idx)}
                className={`h-2 rounded-pill transition-all ${idx === i ? 'w-6 bg-brand' : 'w-2 bg-white/40'}`}
                aria-label={`Go to banner ${idx + 1}`}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
